<form *ngIf="reportFormGroup" [formGroup]="reportFormGroup">
  <p-accordion [multiple]="true">
    <p-accordionTab header="Configuración" [selected]="true">
      <div class="grid">
        <div class="col-6 input-field">
          <label for="name">Nombre *</label>
          <input pInputText name="name" formControlName="name" d-form-field-error />
        </div>
        <div class="col input-field col-4">
          <label for="datasetId">Conjunto de datos</label>
          <p-dropdown [options]="datasets" formControlName="datasetId" optionValue="id" [filter]="true" appendTo="body"
            filterBy="name" optionLabel="name" placeholder="Seleccione dataset" (onChange)="datasetSelected()"
            d-form-field-error [disabled]="!!report.id" />
        </div>
        <div class="col input-field col-2">
          <label for="useSnapshot">Usar snapshot</label>
          <p-checkbox formControlName="useSnapshot" [binary]="true" inputId="useSnapshot"></p-checkbox>
        </div>
      </div>
      <div class="grid">
        <div class="col-12 input-field">
          <label for="description">Descripción</label>
          <p-editor name="description" formControlName="description" d-form-field-error
            [style]="{ height: '200px' }">
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <select class="ql-header" aria-label="Estilo"></select>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Negrita"></button>
                <button type="button" class="ql-italic" aria-label="Cursiva"></button>
                <button type="button" class="ql-underline" aria-label="Subrayado"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color" aria-label="Color"></select>
                <select class="ql-background" aria-label="Color de fondo"></select>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered" aria-label="Lista de números"></button>
                <button type="button" class="ql-list" value="bullet" aria-label="Lista de puntos"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-link" aria-label="Enlace"></button>
                <select class="ql-align" aria-label="Alineación"></select>
              </span>
            </ng-template>
          </p-editor>
        </div>
      </div>
      <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && report.id" icon="pi pi-trash" styleClass="p-button-danger"
          (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab header="Filtros" [selected]="true">
      <div class="grid" *ngFor="let filter of config.filters; let i = index">
        <div class="col-1" style="display: flex; align-items: flex-end; width: 50px;">
          <p-button *ngIf="allowDelete" (click)="deleteFilter(i)" [rounded]="true" [text]="false"
            severity="danger"><i class="pi pi-trash"></i></p-button>
        </div>
        <div class="col input-field col-2">
          <label for="datasetFieldId">Campo de datos</label>
          <p-dropdown placeholder="Seleccione" [(ngModel)]="filter.datasetFieldId" [options]="datasetsFields"
            [ngModelOptions]="{standalone: true}" showClear name="datasetFieldId" appendTo="body"
            [filter]="true" optionLabel="label" optionValue="id"
            (onChange)="onDatasetFieldChange($event, filter)"></p-dropdown>
        </div>
        <div class="col input-field col-2">
          <label for="label">Etiqueta</label>
          <input [ngModelOptions]="{standalone: true}" type="text" pInputText [(ngModel)]="filter.label"/>
        </div>
        <div class="col-2 input-field" *ngIf="filter.dataType !== 'bool'">
          <label for="operator">Operador</label>
          <p-dropdown placeholder="Seleccione" [(ngModel)]="filter.operator" [options]="filter.operators"
            [ngModelOptions]="{ standalone: true }" showClear name="operator" appendTo="body"
            optionLabel="label" optionValue="value">
          </p-dropdown>
        </div>
        <div class="col-2 input-field" *ngIf="(!filter.dropdownOptions || filter.dropdownOptions.length == 0) && filter.operator !== 'IS NULL'">
          <label for="value">Valor</label>
          <input [ngModelOptions]="{standalone: true}" type="text" pInputText [(ngModel)]="filter.value"
            *ngIf="filter.dataType !== 'date' && filter.dataType !== 'datetime' && filter.dataType !=='bool' && filter.dataType !=='number'" />
          <input [ngModelOptions]="{standalone: true}" type="number" pInputText [(ngModel)]="filter.value"
            *ngIf="filter.dataType === 'number'" (ngModelChange)="filter.value = '' + $event" />
          <p-dropdown placeholder="Seleccione" [(ngModel)]="filter.value" [options]="arrayYesNo"
            [ngModelOptions]="{ standalone: true }" showClear name="yesNo" appendTo="body" optionLabel="name"
            optionValue="id" *ngIf="filter.dataType === 'bool'">
          </p-dropdown>
          <p-dropdown placeholder="Seleccione" [(ngModel)]="filter.value" [options]="arrayDates"
            [ngModelOptions]="{ standalone: true }" showClear name="dates" appendTo="body" optionLabel="name"
            optionValue="id" *ngIf="filter.dataType === 'date'">
          </p-dropdown>                    
        </div>        
        <div class="col-2 input-field" *ngIf="(filter.dataType === 'date' || filter.dataType === 'datetime') && 
        filter.value==='CUSTOM' && filter.value!= null">
          <label for="value">Fecha</label>
          <p-calendar [(ngModel)]="filter.value"
            [ngModelOptions]="{ standalone: true }" [showIcon]="true" dateFormat="dd/mm/yy">
          </p-calendar>
        </div>
        <div class="col-2 input-field" *ngIf="filter.dropdownOptions && filter.dropdownOptions.length > 0">
          <label for="value">Valor</label>
          <p-multiSelect [options]="filter.dropdownOptions" optionLabel="Name" optionValue="Id"
            [(ngModel)]="filter.value" [ngModelOptions]="{ standalone: true }"
            placeholder="Selecciona una o más opciones" appendTo="body" showClear>
          </p-multiSelect>

        </div>
        <div class="col-2 input-field">
          <label for="value">Preguntar al usuario</label>
          <p-inputSwitch [(ngModel)]="filter.askUser" [ngModelOptions]="{standalone: true}" d-form-field-error></p-inputSwitch>          
        </div>
      </div>
      <div class="grid mt-2">
        <div class="col p-field">
          <p-button label="Añadir filtro" icon="pi pi-plus" (click)="addFilter()"></p-button>
        </div>
      </div>
    </p-accordionTab>

    <p-accordionTab header="Informe" [selected]="true">

      <div class="grid align-items-center">
        <div class="col input-field col-4" style="display: flex; align-items: center; gap: 0.5rem;">
          <p-multiSelect [options]="datasetsFields" [(ngModel)]="selectedColumns" optionLabel="label"
            selectedItemsLabel="{0} Columnas seleccionadas" [style]="{'min-width': '200px'}"
            placeholder="Seleccione columnas" [ngModelOptions]="{standalone: true}">
          </p-multiSelect>
          <p-button label="Añadir columnas" icon="pi pi-plus" (click)="addColumns(false)"></p-button>
        </div>
      </div>

      <p-table #grid [lazy]="true" [value]="config?.columns" [paginator]="false" [scrollable]="true" scrollHeight="flex"
        [reorderableColumns]="true" (onRowReorder)="onRowReorder($event, 'columns')"  editMode="cell" >
        <ng-template pTemplate="header">
          <tr>
            <th width="35"></th>
            <th>Propiedad</th>
            <th>Columna</th>
            <th>Función de agregación</th>
            <th>Función de resumen</th>
            <!--<th>Nombre</th>-->
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-index="rowIndex" let-editing="editing">
          <tr [pReorderableRow]="index">
            <td width="35">
              <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td>{{item.datasetField}}</td>
            <td [pEditableColumn]="item.label" pEditableColumnField="label">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input
                            pInputText
                            type="text"                            
                          [(ngModel)]="item.label" [ngModelOptions]="{standalone: true}"
                            fluid />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.label }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td [pEditableColumn]="item.aggregation" pEditableColumnField="aggregation">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input
                            pInputText
                            type="text"                            
                          [(ngModel)]="item.aggregation" [ngModelOptions]="{standalone: true}"
                            fluid />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.aggregation }}
                    </ng-template>
                </p-cellEditor>
            </td>  
            <td [pEditableColumn]="item.summarize" pEditableColumnField="summarize">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input
                            pInputText
                            type="text"                            
                          [(ngModel)]="item.summarize" [ngModelOptions]="{standalone: true}"
                            fluid />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.summarize }}
                    </ng-template>
                </p-cellEditor>
            </td>            
            <td width="100">
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteColumnItem(item)" [rounded]="true" [text]="false"
                  severity="danger"><i class="pi pi-trash"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="3">
              No se han econtrado columnas
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>


    <p-accordionTab header="Orden" [selected]="true">

      <div class="grid align-items-center">
        <div class="col input-field col-4" style="display: flex; align-items: center; gap: 0.5rem;">
          <p-multiSelect [options]="datasetsFields" [(ngModel)]="selectedOrderByColumns" optionLabel="label"
            selectedItemsLabel="{0} Columnas seleccionadas" [style]="{'min-width': '200px'}"
            placeholder="Seleccione columnas" [ngModelOptions]="{standalone: true}">
          </p-multiSelect>
          <p-button label="Añadir columnas" icon="pi pi-plus" (click)="addOrderByItem(false)"></p-button>
        </div>
      </div>

      <p-table #grid [lazy]="true" [value]="config?.orderBy" [paginator]="false" [scrollable]="true" scrollHeight="flex"
        [reorderableColumns]="true" (onRowReorder)="onRowReorder($event, 'orderBy')"  editMode="cell" >
        <ng-template pTemplate="header">
          <tr>
            <th width="35"></th>
            <th>Propiedad</th>
            <th>ASC/DESC</th>
            <!--<th>Nombre</th>-->
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-index="rowIndex" let-editing="editing">
          <tr [pReorderableRow]="index">
            <td width="35">
              <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td>{{item.datasetField}}</td>
            <td [pEditableColumn]="item.direction" pEditableColumnField="label">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input
                            pInputText
                            type="text"                            
                          [(ngModel)]="item.direction" [ngModelOptions]="{standalone: true}"
                            fluid />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.direction }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td width="100">
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteOrderByItem(item)" [rounded]="true" [text]="false"
                  severity="danger"><i class="pi pi-trash"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="3">
              No se han econtrado columnas
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>

    <p-accordionTab header="Agrupación" [selected]="true">

      <div class="grid align-items-center">
        <div class="col input-field col-4" style="display: flex; align-items: center; gap: 0.5rem;">
          <p-multiSelect [options]="datasetsFields" [(ngModel)]="selectedGroupByColumns" optionLabel="label"
            selectedItemsLabel="{0} Columnas seleccionadas" [style]="{'min-width': '200px'}"
            placeholder="Seleccione columnas" [ngModelOptions]="{standalone: true}">
          </p-multiSelect>
          <p-button label="Añadir columnas" icon="pi pi-plus" (click)="addGroupByItem(false)"></p-button>
        </div>
      </div>

      <p-table #grid [lazy]="true" [value]="config?.group" [paginator]="false" [scrollable]="true" scrollHeight="flex"
        [reorderableColumns]="true" (onRowReorder)="onRowReorder($event, 'group')"  editMode="cell" >
        <ng-template pTemplate="header">
          <tr>
            <th width="35"></th>
            <th>Propiedad</th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-index="rowIndex" let-editing="editing">
          <tr [pReorderableRow]="index">
            <td width="35">
              <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td>{{item.datasetField}}</td>
            <td width="100">
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteGroupByItem(item)" [rounded]="true" [text]="false"
                  severity="danger"><i class="pi pi-trash"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="3">
              No se han econtrado columnas
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>

    <p-accordionTab header="Permisos" [selected]="true" *ngIf="report?.id">
      <app-reports-users-groups-permissions-list [report]="report"></app-reports-users-groups-permissions-list>
      <!--<p-tabView>
        <p-tabPanel header="Usuarios">
            <div class="flex justify-content-end">
                <p-button label="Añadir usuario" *ngIf="allowWrite" icon="pi pi-plus" styleClass=""
                    (click)="editUserGroupPermission('USER', null)"></p-button>
            </div>

            <p-table styleClass="m-1 mt-4" #grid [value]="usersPermissions" [loading]="loading" [paginator]="false"                                
                 [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="user.name">Usuario <p-sortIcon field="user.name" /></th>
                        <th pSortableColumn="allowRead">Lectura <p-sortIcon field="allowRead" /></th>
                        <th pSortableColumn="allowWrite">Escritura <p-sortIcon field="allowWrite" /></th>
                        <th [width]="150"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-userPermission let-columns="columns">
                    <tr (dblclick)="editUserGroupPermission('USER', userPermission)">
                        <td>{{userPermission.user?.name}}</td>
                        <td>
                          <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': userPermission.allowRead, 'text-red-500 pi-times-circle': !userPermission.allowRead }"></i>
                        </td> 
                        <td>
                          <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': userPermission.allowWrite, 'text-red-500 pi-times-circle': !userPermission.allowWrite }"></i>
                        </td> 
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteUserGroup(userPermission)"
                                    [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editUserGroupPermission('USER', userPermission)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="4">        
                       No se han encontrado usuarios
                    </td>
                  </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Grupos">
          <div class="flex justify-content-end">
            <p-button label="Añadir grupo" *ngIf="allowWrite" icon="pi pi-plus" styleClass=""
                (click)="editUserGroupPermission('GROUP', null)"></p-button>
          </div>

          <p-table styleClass="m-1 mt-4" #grid [value]="groupsPermissions" [loading]="loading" [paginator]="false"
               [scrollable]="true" scrollHeight="flex"
              paginatorDropdownAppendTo="body">
              <ng-template pTemplate="header" let-columns>
                  <tr>
                      <th pSortableColumn="group.name">Grupo <p-sortIcon field="group.name" /></th>
                      <th pSortableColumn="allowRead">Lectura <p-sortIcon field="alloRead" /></th>
                      <th pSortableColumn="allowWrite">Escritura <p-sortIcon field="allowWrite" /></th>
                      <th [width]="150"></th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-groupPermission let-columns="columns">
                  <tr (dblclick)="editUserGroupPermission('GROUP', null)">
                      <td>{{groupPermission.group?.name}}</td>
                      <td>
                        <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': groupPermission.allowRead, 'text-red-500 pi-times-circle': !groupPermission.allowRead }"></i>
                      </td> 
                      <td>
                        <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': groupPermission.allowWrite, 'text-red-500 pi-times-circle': !groupPermission.allowWrite }"></i>
                      </td> 
                      <td>
                          <div class="flex gap-2 justify-content-end">
                              <p-button *ngIf="allowDelete" (click)="deleteUserGroup(groupPermission)"
                                  [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                              <p-button *ngIf="allowWrite" (click)="editUserGroupPermission('GROUP', groupPermission)" [rounded]="true"
                                  [text]="false"><i class="pi pi-pencil"></i></p-button>
                          </div>
                      </td>
                  </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="4">        
                     No se han encontrado grupos
                  </td>
                </tr>
              </ng-template>
          </p-table>
      </p-tabPanel>
    </p-tabView>-->
    </p-accordionTab>
  </p-accordion>
</form>
<p-confirmDialog></p-confirmDialog>